import * as service from './healthsafety.service'
export default {
  data() {
    return {
      compliance_columns: ['PlanDate', 'ProfileItemName', 'PlanResponsibleUser', 'PlanFrequency', 'AllInOne', 'Actions'],
      optionstable: {
        skin: this.$hydrowareCommonJS.hydrowareTableSkin,
        headings: {
          PlanDate: 'Date',
          ProfileItemName: 'Item Name',
          PlanResponsibleUser: 'Responsibility',
          PlanFrequency: 'Frequency',
          AllInOne: '',
          Actions: ''
        },
        columnsClasses: {
          "Actions":"hydroware-2-button-column",
          "ProfileItemName":"hidden-xs hidden-sm",
          "PlanDate":"hydroware-date-column hidden-xs hidden-sm",
          "PlanResponsibleUser":"hydroware-name-column hidden-xs hidden-sm",
          "PlanFrequency":"hydroware-frequency-colomn hidden-xs hidden-sm",
          "AllInOne":"hydroware-label-in-column hidden-md hidden-lg hidden-xl"
        },
        labelPosition: 'top',

        /*    isediting: false,
         EditableColID: '',
         role: '',*/
        // sortIcon: {base: 'glyphicon', up: 'glyphicon-chevron-up', down: 'glyphicon-chevron-down'},
        perPage: 5,
        perPageValues: [5, 10, 25, 50, 100],
        /*  sortable: ["ActionDate","Description", "CommentedBy", "ActionTypeName"],*/
        sortable: ['PlanDate', 'ProfileItemName', 'PlanResponsibleUser', 'PlanFrequency'],
        texts: {
          filterPlaceholder: 'Search...',
          limit: 'rows per page:',
          noResults: 'No matching records',
        }
      },

      addMaintenance: {
        'MaintenanceId': '',
        'LocationId': '',
        'ProfileItemName': '',
        'ProfileMake': '',
        'ProfileModelNo': '',
        'ProfileSerialNumber': '',
        'ProfileDescription': '',
        'PlanFrequency': '',
        'PlanDate': '',
        'PlanResponsibility': '',
        'PlanPriority': '',
        'PlanDescription': '',
        'MaintenanceInventoryList': [],
        'PlanResponsibleUser': ''
      },
      addComplianceCopy: {},
      rules: {

        ProfileItemName: [

          {
            required: true,
            message: 'This field is required'
          },
          {
            min: 1,
            max: 50,
            message: 'Length should be 1 to 50'
          }
        ],
        ProfileMake: [

          {
            required: true,
            message: 'This field is required'
          },
          {
            min: 1,
            max: 50,
            message: 'Length should be 1 to 50'
          }
        ],
        PlanDate: [{
          type: 'date',
          required: true,
          message: 'This field is required'
        }, ],
        PlanResponsibility: [

          {
            required: true,
            message: 'This field is required'
          },

        ],
        PlanPriority: [

          {
            required: true,
            message: 'This field is required'
          },

        ],

      },
      mitems: [],
      cinventories: [],
      types: [],
      makes: [],
      locationId: '',
      suppliers: [],
      categories: [],
      Users: [],
      eindex: 's',
      selectedInventoryType: '',
      selectedInventoryCategory: '',
      selectedInventoryInventory: '',
      selectedInventoryItem: '',
      Quantity: '',
      Notes: '',
      locationName: '',
      modalTitle: '',

      isediting: false,
      isaddding: false,
      isAddingOrEditing: "" //FG - After Cert - First Release Security (7) added this variable for use when disabling fields in the el-form

    }
  },
  mounted() {
    let context = this
    this.$router.app.$on('emittedlocation_obj', (data) => {
      context.locationId = data.LocationId ? data.LocationId : ''
      context.locationName = data.LocationName ? ' - ' + data.LocationName : ''
      context.GetMaintenance(context.locationId)
      // alert(JSON.stringify(data))
      context.PreRequisites(context.locationId)
      this.GetAllUsers(this.locationId)
    })

  },

  methods: {

    addCompliancevit() {
      this.isaddding = true
      this.isAddingOrEditing="A" //FG - FOOF - After Cert - First Release Security (7) - added isAddingOrEditing for use when disabling el-form

      this.addMaintenance = {
        'MaintenanceId': '',
        'LocationId': '',
        'ProfileItemName': '',
        'ProfileMake': '',
        'ProfileModelNo': '',
        'ProfileSerialNumber': '',
        'ProfileDescription': '',
        'PlanFrequency': '',
        'PlanDate': '',
        'PlanResponsibility': '',
        'PlanPriority': '',
        'PlanDescription': '',
        'MaintenanceInventoryList': [],
        'PlanResponsibleUser': ''
      }

    },
    showCompliancevit() {
      this.isaddding = false
      this.isediting = false
      this.isAddingOrEditing=""
      this.eindex = 's'
    },

    //FG - FOOF - renamed the method below
    //     changed the first param that is passed into the function so that it is
    //        now the inventory type id rather than an full object.  Why ?  because
    //        by doing so I can now use this function to set things up for a line
    //        item that is being edited and also when a user changes a choice in
    //        the "type" drop down.
    //     added the "chosenCategoryId" parameter so we know if we need to fill in
    //     a category in the drop down's text field. 
    //        When editing a line item we need to fill in the category from that line item but when
    //        adding a new line item we need to show the default ("select a category")
    //     reworked function and changed variable names in it to be more descriptive
    //     added code to the methos so it will call on the
    //     initializeInventoryForCategoryType(...) function when the chosenCategory
    //     is not null (THIS LAST BIT MAY NOT BE NEEDED)
    //     added comments
    initializeCategoriesForInventoryType(inventoryTypeId,chosenCategoryId=null) {
      let context = this
      context.categories = []
      let chosenCategory = null //This will be filled in when we loop thru the categories
      if(inventoryTypeId != null) {
        this.types.map(function (aType) {
          aType['InventoryCategoryList'].map(function (aCategory) {
            if (aCategory['TypeIdId'] === inventoryTypeId) {
              context.categories.push(aCategory)
              //If the category that was just pushed into the list of catagories
              //is the chosen category then hold onto it so it can be used
              //to set the selectedInventoryCategory later in this function
              if(aCategory.CategoryId == chosenCategoryId)
                chosenCategory = aCategory
            }
          })
        })
        this.selectedInventoryCategory = chosenCategory
        if(chosenCategory == null)
          context.initializeInventoryForCategoryType(chosenCategoryId)
      }
    },
    //FG - FOOF - renamed the method below... SEE THE COMMENTS ABOVE THE
    //     FUNCTION: initializeCategoriesForInventoryType
    //     I MADE SIMILAR CHANGES TO THE METHOD BELOW
    initializeInventoryForCategoryType(categoryTypeId,chosenInventoryId=null) {
      let context = this
      context.cinventories = []
      let chosenInventory = null; //this will be filled in when we loop thru the inventory list
      if(categoryTypeId != null)
        this.categories.map(function (aCategory) {
          aCategory['InventoryList'].map(function (anInventory) {
            if (anInventory['InventoryCategoryId'] === categoryTypeId) {
              context.cinventories.push(anInventory)
              if(anInventory.InventoryId == chosenInventoryId)
                chosenInventory = anInventory
            }
          })
      })
      this.selectedInventoryInventory = chosenInventory //set the value in the input field associated with the el-select
      if(chosenInventory == null) //if nothing is chosen for inventory then force the makes select list to be empty
        this.initializeMakesForInventoryType(chosenInventoryId)
    },
    
    //FG - FOOF - renamed the method below... SEE THE COMMENTS ABOVE THE
    //     FUNCTION: initializeCategoriesForInventoryType
    //     I MADE SIMILAR CHANGES TO THE METHOD BELOW
    initializeMakesForInventoryType(inventoryTypeId,chosenMakeId=null) {
      //alert("init make inv type id: " + inventoryTypeId + "   chosen make: " + chosenMakeId)
      let context = this
      context.makes = []
      let chosenMake = null; //this will be filled in when we loop thru the makes list
      if(inventoryTypeId != null) {
        this.cinventories.map(function (item) {
          item['InventoryDetails'].map(function (item2) {
            context.makes.push(item2)
            if(item2.InventoryDetailsId == chosenMakeId)
                chosenMake = item2
          })
        })
      }
      this.selectedInventoryItem = chosenMake
    },

    Getmakes(id) {

      let context = this
      context.makes = []
      this.cinventories.map(function (item) {
        item['InventoryDetails'].map(function (item2) {
          //alert(JSON.stringify(item2))
          context.makes.push(item2)
        })
      })
    },





    checkNumber() {

      this.Quantity = this.Quantity.replace(/[^0-9]/g, "");

    },



    AddtoList() {

      if (this.selectedInventoryItem && this.Quantity && this.selectedInventoryInventory && this.selectedInventoryType && this.selectedInventoryCategory) {
        let mod = {

          'InventoryDetailsId': this.selectedInventoryItem.InventoryDetailsId,
          'Quantity': this.Quantity,
          'Notes': this.Notes,
          'InventoryId': this.selectedInventoryInventory,
          'ItemName': this.selectedInventoryInventory.ItemName,
          'CategoryId': this.selectedInventoryCategory,
          'CategoryName': this.selectedInventoryCategory.CategoryName,
          'TypeId': this.selectedInventoryType,
          'TypeName': this.selectedInventoryType.TypeName,
          'Brand': this.selectedInventoryItem.Brand,

        }

        var elexists = false
        var titem
        var citem
        var iitem
        var iiditem
        var titem1
        var citem1
        var iitem1
        var iiditem1
        if (mod.TypeId.TypeId) {
          titem = mod.TypeId.TypeId
        } else {
          titem = mod.TypeId
        }

        if (mod.CategoryId.CategoryId) {
          citem = mod.CategoryId.CategoryId
        } else {
          citem = mod.CategoryId
        }

        if (mod.InventoryId.InventoryId) {
          iitem = mod.InventoryId.InventoryId
        } else {
          iitem = mod.InventoryId
        }

        if (mod.InventoryDetailsId.InventoryDetailsId) {
          iiditem = mod.InventoryDetailsId.InventoryDetailsId
        } else {
          iiditem = mod.InventoryDetailsId
        }
        if (this.addMaintenance.MaintenanceInventoryList.length > 0) {

          this.addMaintenance.MaintenanceInventoryList.map(function (item) {
            if (item.TypeId.TypeId) {
              titem1 = mod.TypeId.TypeId
            } else {
              titem1 = item.TypeId
            }

            if (item.CategoryId.CategoryId) {
              citem1 = item.CategoryId.CategoryId
            } else {
              citem1 = item.CategoryId
            }

            if (item.InventoryId.InventoryId) {
              iitem1 = item.InventoryId.InventoryId
            } else {
              iitem1 = item.InventoryId
            }

            if (item.InventoryDetailsId.InventoryDetailsId) {
              iiditem1 = item.InventoryDetailsId.InventoryDetailsId
            } else {
              iiditem1 = item.InventoryDetailsId
            }

            if (iiditem1 == iiditem && iitem1 == iitem && citem1 == citem && titem1 == titem) {
              elexists = true

            }

          })

        }

        if (elexists == false) {
          this.addMaintenance.MaintenanceInventoryList.push(mod)

        } else {
          this.$notify({
            title: 'Error',
            message: 'Item already exists in inventory list',
            type: 'error'
          })
        }

        this.selectedInventoryItem = ''
        this.Quantity = ''
        this.Notes = ''
        this.selectedInventoryInventory = ''
        this.selectedInventoryCategory = ''
        this.selectedInventoryType = ''
        this.selectedInventoryItem = ''

      }
    },
    UpdateList() {
      let context = this
      if (this.selectedInventoryItem && this.Quantity && this.selectedInventoryInventory && this.selectedInventoryType && this.selectedInventoryCategory) {
        let mod = {

          'InventoryDetailsId': this.selectedInventoryItem.InventoryDetailsId,
          'Quantity': this.Quantity,
          'Notes': this.Notes,
          'InventoryId': this.selectedInventoryInventory,
          'ItemName': this.selectedInventoryInventory.ItemName,
          'CategoryId': this.selectedInventoryCategory,
          'CategoryName': this.selectedInventoryCategory.CategoryName,
          'TypeId': this.selectedInventoryType,
          'TypeName': this.selectedInventoryType.TypeName,
          'Brand': this.selectedInventoryItem.Brand,

        }

        var elexists = false
        if (this.addMaintenance.MaintenanceInventoryList.length > 0) {

          this.addMaintenance.MaintenanceInventoryList.map(function (item, index) {

            if (item.InventoryDetailsId == mod.InventoryDetailsId && item.InventoryId == mod.InventoryId && item.CategoryId == mod.CategoryId && item.TypeId == mod.TypeId) {
              if (context.eindex != index) {
                elexists = true
              }
            }

          })

        }

        if (elexists == false) {

          this.addMaintenance.MaintenanceInventoryList[this.eindex] = mod

        } else {
          this.$notify({
            title: 'Error',
            message: 'Item already exists in inventory list',
            type: 'error'
          })
        }

        this.selectedInventoryItem = ''
        this.Quantity = ''
        this.Notes = ''
        this.selectedInventoryInventory = ''
        this.selectedInventoryCategory = ''
        this.selectedInventoryType = ''
        this.selectedInventoryItem = ''

        this.eindex = 's'
      }
    },


    //FG - FOOF - 11-29-2018 - SOME COMMENTS FROM THE FOLKS THAT WROTE THIS AT
    //     DIGICLARITY WOULD HAVE BEEN REALLY HELPFUL IN THE FUNCTION BELOW
    editsession(maintenanceLineItem, index) {
      let context = this
      this.eindex = index
      var lineItemTypeId          // was - var titem
      var lineItemCategoryId      //was - var citem
      var lineItemInventoryItemId //was - var iitem
      var lineItemMakeItemId      //was - var iiditem
     
      /*********************************************************************
      **
      ** FG - FOOF - I'm not sure how it happens but sometimes objects are
      ** passed in and sometimes simple numeric ids.... Digiclarity had the
      ** if/else statements below to cover that.
      **
      **********************************************************************/
      if (maintenanceLineItem.TypeId.TypeId) {
        lineItemTypeId = maintenanceLineItem.TypeId.TypeId
      } else {
        lineItemTypeId = maintenanceLineItem.TypeId
      }
      
      if (maintenanceLineItem.CategoryId.CategoryId) {
        lineItemCategoryId = maintenanceLineItem.CategoryId.CategoryId
      } else {
        lineItemCategoryId = maintenanceLineItem.CategoryId
      }

      if (maintenanceLineItem.InventoryId.InventoryId) {
        lineItemInventoryItemId = maintenanceLineItem.InventoryId.InventoryId
      } else {
        lineItemInventoryItemId = maintenanceLineItem.InventoryId
      }

      if (maintenanceLineItem.InventoryDetailsId.InventoryDetailsId) {
        lineItemMakeItemId = maintenanceLineItem.InventoryDetailsId.InventoryDetailsId
      } else {
        lineItemMakeItemId = maintenanceLineItem.InventoryDetailsId
      }

      //alert("EDIT A LINE ITEM\ntype: " + lineItemTypeId + "\ncat: " + lineItemCategoryId 
      //+ "\ninv: " + lineItemInventoryItemId + "\nmake: " + lineItemMakeItemId)

      /************************************************************************************
      ** FG - added comment
      ** Loop thru the types and set the selected type to the one that is on the line item
      ** to be edited. 
      ** I believe that when setting the context.selectedInventoryType an el-select @change
      ** event is triggered.
      ************************************************************************************/
      context.types.map(function (obj) {
        if (obj.TypeId == lineItemTypeId) {
          context.selectedInventoryType = obj
        }
      })
      
      context.initializeCategoriesForInventoryType(lineItemTypeId, lineItemCategoryId);
      context.initializeInventoryForCategoryType(lineItemCategoryId,lineItemInventoryItemId);
      context.initializeMakesForInventoryType(lineItemInventoryItemId,lineItemMakeItemId);
/* ??????????????????? CAN I DO THIS DIFFERENTLY ??????????????????????
      setTimeout(function () {
        context.categories.map(function (obj) {

          if (obj.CategoryId == lineItemCategoryId) {
            context.selectedInventoryCategory = obj
            setTimeout(function () {
              context.cinventories.map(function (obj) {

                if (obj.InventoryId == inventoryItem) {
                  context.selectedInventoryInventory = obj

                  setTimeout(function () {
                    context.makes.map(function (obj) {

                      if (obj.InventoryDetailsId == makeItem) {
                        context.selectedInventoryItem = obj
                      }

                    })
                  }, 100)
                }

              })

            }, 100)
          }

        })

      }, 100)
????????????????????????????????? ABOVE */
      this.Quantity = maintenanceLineItem.Quantity
      this.Notes = maintenanceLineItem.Notes
    },

    removeSession(index) {
      this.addMaintenance.MaintenanceInventoryList.splice(index, 1)

      this.eindex = "s"

      this.selectedInventoryItem = ''
      this.Quantity = ''
      this.Notes = ''
      this.selectedInventoryInventory = ''
      this.selectedInventoryCategory = ''
      this.selectedInventoryType = ''
      this.selectedInventoryItem = ''
    },
    PreRequisites(id) {
      let context = this
      loader.startLoader()
      service.GetPrerequisites(id).then(function (response) {

        if (response && response != null) {

          context.types = response['Inventories']
          // context.suppliers = response.supplier
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    GetAllUsers(locationId) {
      let context = this
      loader.startLoader()
      service.GetAllUsers(locationId).then(function (response) {

        if (response && response != null) {
          context.Users = response
          tooltip.startTooltip()
        } else {

          context.Users = []
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    


    GetMaintenance(locationId) {
      let context = this
      loader.startLoader()
      service.GetMaintenance(locationId).then(function (response) {

        //FG - FOOF - After Cert - First Release Security (7) Can the user at least view the data ?
        if(context.$hydrowareSecurityJS.isDataRestricted(response)) {
          context.mitems = []
          return;
        }
        //FG - FOOF - After Cert - First Release Security (7) - above
        if (response && response != null) {
          context.mitems = response
        } else {

          context.mitems = []
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    //FG - FOOF - After Cert - First Release (6) - rewrote delete code below to use new methods in hydrowareCommonJS.js
    //The delete function below deletes a row from the table
    del: function (data) {
      var ID = data.row.MaintenanceId
      let context = this
      var opts = {message: 'Are you sure you want to delete: ' + data.row.ProfileItemName +'?'}
      context.$hydrowareCommonJS.displayConfirmDeletePopup(context, opts, context.deleteMaintenanceRow.bind(null,ID))
    },
    deleteMaintenanceRow(ID) {
      var context=this;
      loader.startLoader()
      service.DeleteMaintenance(ID).then(function (response) {

        //FG - FOOF - After Cert - First Release Security - added conditional statement below
        //ADDED AFTER SERVER SIDE SECURITY WAS IN PLACE - SERVER SIDE SECURITY CHECK EXAMPLE
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {
          loader.stopLoader()  
          return;
        }

        context.GetMaintenance(context.locationId)
        loader.stopLoader()
        context.$hydrowareCommonJS.notifyDeleteSuccess(context);

      }, (error) => {
        loader.stopLoader()
        context.$hydrowareCommonJS.notifyError(context,{message: error.responseJSON.Message})
      })
    },

    cancelpopup: function () {
      $('#Addkudosmodel').modal('hide')
    },

    editcol: function (data) {

      var ID = data.row.MaintenanceId
      let context = this
      context.EditableColID = ID
      context.addMaintenance = data.row
      context.addMaintenance['MaintenanceId'] = ID
      context.addMaintenance['PlanDate'] = new Date(data.row['PlanDate'])
      context.isediting = true
      context.isAddingOrEditing="E"
    },

    AddMaintenance(formName) {

      let context = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let context1 = this
          loader.startLoader()

          context.addMaintenance['LocationId'] = context.locationId
          context.addMaintenance['PlanDate'] = context.$options.filters.fdate(context.addMaintenance['PlanDate'])

          service.AddMaintenance(context.addMaintenance).then(function (response) {

            loader.stopLoader()

            //FG - FOOF - After Cert - First Release Security - added conditional statement below
            //ADDED AFTER SERVER SIDE SECURITY WAS IN PLACE - SERVER SIDE SECURITY CHECK EXAMPLE
            if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{}))
              return;

            context.$notify({
              title: 'Success',
              message: 'Maintenance entry Created',
              type: 'success'
            })
            context.GetMaintenance(context.locationId)
            context.isediting = false
            context.isaddding = false
            context.isAddingOrEditing=""

          }, (error) => {
            context.addMaintenance['PlanDate'] = new Date(context.addMaintenance['PlanDate'])

            loader.stopLoader()

            context.$notify({
              title: 'Error',
              message: error.responseJSON.Message,
              type: 'error'
            })
          })
        } else {
          this.$notify({

            title: 'Error',

            message: 'MAINT - error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },

    UpdateMaintenance(formName) {


      let context = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let context1 = this
          loader.startLoader()
          if (this.addMaintenance.MaintenanceInventoryList.length < 1 || !this.addMaintenance.MaintenanceInventoryList) {
            this.addMaintenance.MaintenanceInventoryList = [""]
          }
          context.addMaintenance['LocationId'] = context.locationId
          context.addMaintenance['PlanDate'] = context.$options.filters.fdate(context.addMaintenance['PlanDate'])

          // context.addCompliance['Id'] =
          service.UpdateMaintenance(context.addMaintenance).then(function (response) {

            loader.stopLoader()

            //FG - FOOF - After Cert - First Release Security - added conditional statement below
            //ADDED AFTER SERVER SIDE SECURITY WAS IN PLACE - SERVER SIDE SECURITY CHECK EXAMPLE
            if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {          
              return;
            }

            context.$notify({
              title: 'Success',
              message: 'Maintenance details Updated',
              type: 'success'
            })
            context.GetMaintenance(context.locationId)
            context.isediting = false
            context.isaddding = false
            context.isAddingOrEditing=""

          }, (error) => {
            context.addMaintenance['PlanDate'] = new Date(context.addMaintenance['PlanDate'])
            loader.stopLoader()

            context.$notify({
              title: 'Error',
              message: error.responseJSON.Message,
              type: 'error'
            })
          })
        } else {
          return false
        }
      })
    },

    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
  watch: {

    isediting: function (val) {
      this.$router.app.$emit('sidebar_hide', val)
    },
    isaddding: function (val) {

      this.$router.app.$emit('sidebar_hide', val)
    }

  },
}



// WEBPACK FOOTER //
// ./src/pages/HealthSafety/maintenance.controller.js